import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import UserChip from './UserChip';
import Wordmark from './Wordmark';

const PROJECT_PILLAR_ITEMS = [
  { label: 'Governance',          color: '#534AB7', bg: '#EEEDFE', icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><path d="M2 4h10M2 7h6M2 10h4"/></svg> },
  { label: 'Management',          color: '#1D9E75', bg: '#E1F5EE', icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><rect x="1" y="2" width="12" height="2" rx="1"/><rect x="1" y="6" width="8" height="2" rx="1"/><rect x="1" y="10" width="10" height="2" rx="1"/></svg> },
  { label: 'Workbench',           color: '#EF9F27', bg: '#FAEEDA', icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><rect x="2" y="1" width="10" height="12" rx="1.5"/><path d="M4 5h6M4 7.5h4"/></svg> },
  { label: 'Finance & reporting', color: '#185FA5', bg: '#E6F1FB', icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><path d="M2 10l3-3 2 2 5-5"/></svg> },
];

function IconBtn({ item, active, onClick }) {
  const [hover, setHover] = useState(false);
  return (
    <div style={{ position: 'relative' }} onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
      <button
        type="button"
        onClick={onClick}
        style={{
          width: 36, height: 36, borderRadius: 8, border: 'none', cursor: 'pointer',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: active ? (item.bg || '#EEEDFE') : hover ? '#f1efe8' : 'transparent',
          color: active ? (item.color || '#534AB7') : '#888780',
          transition: 'background 0.1s',
        }}
      >
        {item.icon}
      </button>
      {hover && (
        <div style={{
          position: 'absolute', left: 44, top: '50%', transform: 'translateY(-50%)',
          background: '#2c2c2a', color: '#fff', fontSize: 11, padding: '4px 9px',
          borderRadius: 6, whiteSpace: 'nowrap', pointerEvents: 'none', zIndex: 9999,
        }}>
          {item.label}
        </div>
      )}
    </div>
  );
}

function SidebarFooter({ collapsed }) {
  return <UserChip collapsed={collapsed} />;
}

export default function Sidebar({ projectNav }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div style={{
      width: collapsed ? 48 : 232,
      background: '#fff',
      borderRight: '0.5px solid #d3d1c7',
      display: 'flex',
      flexDirection: 'column',
      flexShrink: 0,
      transition: 'width 0.2s ease',
      overflow: 'visible',
      position: 'relative',
      alignSelf: 'stretch',
      minHeight: 0,
    }}>

      {!collapsed && (
        <div style={{ padding: '14px 16px 12px', borderBottom: '0.5px solid #d3d1c7', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexShrink: 0 }}>
          <div>
            <Wordmark />
            <div className="logo-sub">Transformation programme platform</div>
          </div>
          <button type="button" className="toggle-btn" onClick={() => setCollapsed(true)}>‹</button>
        </div>
      )}

      {collapsed && (
        <div style={{ padding: '12px 0', borderBottom: '0.5px solid #d3d1c7', display: 'flex', justifyContent: 'center', flexShrink: 0 }}>
          <button type="button" className="toggle-btn" style={{ width: 28, height: 28 }} onClick={() => setCollapsed(false)}>›</button>
        </div>
      )}

      {!collapsed && (
        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <div className="nav-full" style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
            {projectNav ? (
              <>
                <div className="ni" onClick={() => navigate('/home')} style={{ cursor: 'pointer' }}>
                  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="#888780" strokeWidth="1.2" strokeLinecap="round"><path d="M9 11L5 7l4-4"/></svg>
                  Back to programmes
                </div>
                <div style={{ padding: '10px 8px 3px', fontSize: 10, color: '#888780', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Project</div>
                {projectNav.map((item, i) => (
                  <div key={i} className={`ni ${item.active ? 'active' : ''}`} onClick={item.onClick} style={{ cursor: 'pointer' }}>
                    {item.icon}{item.label}
                  </div>
                ))}
                <div style={{ padding: '10px 8px 3px', fontSize: 10, color: '#888780', textTransform: 'uppercase', letterSpacing: '0.8px' }}>Pillars</div>
                {PROJECT_PILLAR_ITEMS.map((item, i) => (
                  <div key={i} className="ni" style={{ cursor: 'pointer' }}>
                    <span style={{ color: item.color }}>{item.icon}</span>{item.label}
                  </div>
                ))}
              </>
            ) : (
              <div className={`ni ${location.pathname === '/home' ? 'active' : ''}`} onClick={() => navigate('/home')} style={{ cursor: 'pointer' }}>
                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><rect x="1" y="1" width="5" height="5" rx="1"/><rect x="8" y="1" width="5" height="5" rx="1"/><rect x="1" y="8" width="5" height="5" rx="1"/><rect x="8" y="8" width="5" height="5" rx="1"/></svg>
                Programmes & projects
              </div>
            )}
          </div>
          <SidebarFooter collapsed={false} />
        </div>
      )}

      {collapsed && (
        <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          <div style={{ padding: '8px 0', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, flex: 1, overflowY: 'auto', overflowX: 'visible', minHeight: 0 }}>
            {projectNav ? (
              <>
                <IconBtn
                  item={{ label: 'Back to programmes', icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><path d="M9 11L5 7l4-4"/></svg> }}
                  active={false}
                  onClick={() => navigate('/home')}
                />
                <div style={{ width: 24, height: 0.5, background: '#d3d1c7', margin: '4px 0' }} />
                {projectNav.map((item, i) => (
                  <IconBtn key={i} item={{ ...item, bg: '#EEEDFE', color: '#534AB7' }} active={item.active} onClick={item.onClick} />
                ))}
                <div style={{ width: 24, height: 0.5, background: '#d3d1c7', margin: '4px 0' }} />
                {PROJECT_PILLAR_ITEMS.map((item, i) => (
                  <IconBtn key={i} item={item} active={false} />
                ))}
              </>
            ) : (
              <IconBtn
                item={{ label: 'Programmes & projects', bg: '#EEEDFE', color: '#534AB7', icon: <svg width="14" height="14" viewBox="0 0 14 14" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round"><rect x="1" y="1" width="5" height="5" rx="1"/><rect x="8" y="1" width="5" height="5" rx="1"/><rect x="1" y="8" width="5" height="5" rx="1"/><rect x="8" y="8" width="5" height="5" rx="1"/></svg> }}
                active={location.pathname === '/home'}
                onClick={() => navigate('/home')}
              />
            )}
          </div>
          <SidebarFooter collapsed />
        </div>
      )}
    </div>
  );
}
